var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","name":"fade"}},[(_vm.status==='idle')?_c('div',{staticClass:"t3m-ImageMap-hotspots"},[_c('div',_vm._l((_vm.hotspots),function(h){return _c('t3m-hotspot',{key:h.id,attrs:{"specs":h}})}),1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }